import React, { Component } from "react";
import { ExpansionPanel, ExpansionPanelSummary } from "@material-ui/core";
import styles from "./Translation.module.scss";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import Input from "@material-ui/core/Input";
import ListItemText from "@material-ui/core/ListItemText";
import ClearIcon from "@material-ui/icons/Clear";
import DoneIcon from "@material-ui/icons/Done";
import { Grid, TextField, withStyles } from "@material-ui/core";
import { LANCODES } from "../../common/Constants";

const PickUpFormControl = withStyles({
  root: {
    width: 200,
  },
})(FormControl);

const PickUpStyledSelect = withStyles({
  select: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    width: "calc(100% - 34px)",
    boxSizing: "border-box",
    fontSize: 14,
    color: "#102b4e",
    lineHeight: 1.57,
    letterSpacing: 1.5,
    fontFamily: "FordAntenna-Regular, sans-serif",
    "&:focus": {
      background: "transparent",
    },
  },
})(Select);

const PickUpStyledMenuItem = withStyles({
  root: {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 10,
    paddingRight: 10,
    margin: 0,
    fontSize: 14,
    color: "#102b4e",
    lineHeight: 1.57,
    letterSpacing: 1.5,
    fontFamily: "FordAntenna-Regular, sans-serif",
  },
})(MenuItem);

class NewComponentTranslation extends Component {
  constructor(props) {
    super(props);
    this.translation = [];
    this.state = {
      newTrans: {
        moduleKey: "",
        key: "",
        en: "",
        de: "",
        fr: "",
        nl: "",
        no: "",
        es: "",
        it: "",
        fi: "",
        da: "",
        cs: "",
        pl: "",
        pt: "",
        el: "",
        ro: "",
        hu: "",
      },
      key: "",
      en: "",
      translatedValue: "",
      moduleKey: "",
      page: [],
    };

    this.lan = this.props.currentLan;
  }

  handleChangeKey = (event) => {
    this.setState({ key: event.target.value });
  };
  handleChangeEn = (event) => {
    this.setState({ en: event.target.value });
  };
  handleChangeTranslatedValue = (event) => {
    this.setState({ translatedValue: event.target.value });
  };
  handleChangeModuleKey = (event) => {
    this.setState({ moduleKey: event.target.value });
  };
  handleChangePageCategory = (event) => {
    this.setState({ page: event.target.value });
  };

  addComponentTranslation = () => {
    const updatedLanguage = { ...this.state.newTrans };
    updatedLanguage.en = this.state.en;
    updatedLanguage.de = this.state.en;
    updatedLanguage.fr = this.state.en;
    updatedLanguage.nl = this.state.en;
    updatedLanguage.no = this.state.en;
    updatedLanguage.es = this.state.en;
    updatedLanguage.it = this.state.en;
    updatedLanguage.fi = this.state.en;
    updatedLanguage.da = this.state.en;
    updatedLanguage.cs = this.state.en;
    updatedLanguage.pl = this.state.en;
    updatedLanguage.pt = this.state.en;
    updatedLanguage.el = this.state.en;
    updatedLanguage.ro = this.state.en;
    updatedLanguage.hu = this.state.en;
    updatedLanguage.key = this.state.key;
    updatedLanguage.moduleKey = this.state.moduleKey;
    updatedLanguage.pages = this.state.page.join(",");
    // instead of loop overwriting the value
    updatedLanguage[this.lan] = this.state.translatedValue;
    this.props.addTranslationComponent(updatedLanguage);
  };

  cancelComponentTranslation = () => {
    // this.props.showNewComponentTranslation();
    this.props.cancelTranslation();
  };

  render() {
    return (
      <div>
        <br />
        {this.props.showNewComponentTranslationvalue && (
          <ExpansionPanel expanded={true}>
            <ExpansionPanelSummary>
              <Grid
                container
                direction="row"
                justify="flex-start"
                alignItems="flex-end"
                spacing={8}
              >
                <Grid item md={3}>
                  <TextField
                    className={styles.inputField}
                    type="text"
                    name="topicBox"
                    variant="outlined"
                    placeholder={this.props.t("Translations.enterModule")}
                    onChange={this.handleChangeModuleKey}
                  />
                </Grid>
                <Grid item md={6}>
                  <PickUpFormControl
                    className={styles.newTranslationMappingPages}
                  >
                    <PickUpStyledSelect
                      multiple
                      className={styles.dropdown}
                      value={this.state.page}
                      onChange={this.handleChangePageCategory}
                      input={<Input />}
                      displayEmpty
                      renderValue={(selected) =>
                        selected.length ? (
                          selected.join(", ")
                        ) : (
                          <span className={styles.inputPlaceholder}>
                            Page Category
                          </span>
                        )
                      }
                    >
                      <PickUpStyledMenuItem value="" disabled>
                        Page Category
                      </PickUpStyledMenuItem>
                      {this.props.pages.map((name) => (
                        <PickUpStyledMenuItem key={name} value={name}>
                          <Checkbox
                            checked={this.state.page.indexOf(name) > -1}
                          />
                          <ListItemText primary={name} />
                        </PickUpStyledMenuItem>
                      ))}
                    </PickUpStyledSelect>
                  </PickUpFormControl>
                </Grid>
              </Grid>
            </ExpansionPanelSummary>

            <Grid container className={styles.translation_header}>
              <Grid item md={3} className={styles.lanHeader}>
                {this.props.t("Translations.key")}
              </Grid>
              <Grid item md={4} className={styles.lanHeader}>
                {LANCODES["en"]}
              </Grid>
              <Grid item md={4} className={styles.lanHeader}>
                {LANCODES[this.props.languageSelected]}
              </Grid>
              <Grid item md={1} className={styles.actionHeader}>
                {this.props.t("Translations.action")}
              </Grid>
            </Grid>
            <div>
              <Grid container className={styles.lan}>
                <Grid item md={3}>
                  <TextField
                    className={styles.inputField}
                    type="text"
                    name="topicBox"
                    variant="outlined"
                    placeholder={this.props.t("Translations.enterKey")}
                    onChange={this.handleChangeKey}
                  />
                </Grid>

                <Grid item md={4}>
                  <TextField
                    className={styles.inputField}
                    type="text"
                    name="topicBox"
                    variant="outlined"
                    placeholder={this.props.t("Translations.enterEng")}
                    onChange={this.handleChangeEn}
                  />
                </Grid>

                <Grid item md={4}>
                  <TextField
                    className={styles.inputField}
                    type="text"
                    name="topicBox"
                    variant="outlined"
                    placeholder={this.props.t("Translations.enterLan")}
                    onChange={this.handleChangeTranslatedValue}
                  />
                </Grid>
                <Grid item md={1} className={styles.lanUpdate}>
                  <DoneIcon
                    fontSize="small"
                    style={{ color: "green" }}
                    className={styles.button_hover}
                    onClick={this.addComponentTranslation}
                  />
                  <ClearIcon
                    fontSize="small"
                    style={{ color: "red" }}
                    className={styles.button_hover}
                    onClick={this.cancelComponentTranslation}
                  />
                </Grid>
              </Grid>
            </div>
          </ExpansionPanel>
        )}
      </div>
    );
  }
}

export default NewComponentTranslation;
